/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { INosAnchorViewProps } from './nos-anchor';

export default (props: INosAnchorViewProps) => {
    return <a id={props.config.idName}></a>;
};
